<template>
  <div id="instrument-alteration">
    <div style="margin-bottom: 10px">
      <el-button  @click="openEditDialog" style="width: 150px"  >选择商品</el-button>
    </div>
    <account type="编辑商品" :product="product"></account>
  </div>
</template>

<script>
import AccountComponent from '@/components/instrument/AccountComponent.vue'
export default {
  name: 'instrument-alteration',
  components: {
    'account': AccountComponent
  },
  data() {
    return {
      product: {},
      machineMessage: '',
    }
  },
  mounted(){

  },
  methods: {
    openEditDialog(){
      let that = this.$root.$children[0].$children[1].$children[0];
      that.selectDialogVisible = true;
      that.$set(that,'childrenObject',this);
    },
  }
}
</script>
<style>
html,body{
  margin: 0;
  height: 100%;
}
#instrument-alteration{
  position: relative;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/instrument/Alteration.vue